import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.CREATE_SHIPPING_USER.REQUEST, saga.createShippingUser);
    yield takeLatest(ACTION.CREATE_SHIPPING_USER.SUCCESS, saga.createShippingUserSuccess);
}
